// Quick play seats one JEV, one smart and one master bot (owner's choice,
// 2026-10-05), at random seats: position relative to the dealer changes how a
// seat plays, so fixed slots would only ever show one side of each bot.
// The server replaces 'jev' with its default bot type when JEV isn't configured.
const QUICKPLAY_BOTS = ['jev', 'smart', 'master'];

export function pickQuickplayBotTypes(random = Math.random) {
  const types = [...QUICKPLAY_BOTS];
  for (let i = types.length - 1; i > 0; i--) {
    const j = Math.floor(random() * (i + 1));
    [types[i], types[j]] = [types[j], types[i]];
  }
  return types;
}
